// extracted by mini-css-extract-plugin
export var buttonWrap = "results-support-module--buttonWrap--0c6a0";
export var card = "results-support-module--card--0f5a4";
export var cardText = "results-support-module--cardText--e7455";
export var cardTitle = "results-support-module--cardTitle--c5376";
export var container = "results-support-module--container--bff72";
export var grid = "results-support-module--grid--3380a";
export var heading = "results-support-module--heading--da25d";
export var highlight = "results-support-module--highlight--b09d1";
export var image = "results-support-module--image--bbb95";
export var root = "results-support-module--root--ebf1c";
export var title = "results-support-module--title--a7e4b";